// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    production_find_production_orders: 'Buscando entre las órdenes de fabricación',
    production_production_order_detail: 'Leyendo la orden de fabricación',
    production_production_summary: 'Sumando el taller',
    production_my_orders: 'Mirando tu puesto',
    production_complete_phase: 'Marcando una fase del taller',
  },
  ca: {
    production_find_production_orders: 'Cercant entre les ordres de fabricació',
    production_production_order_detail: 'Llegint l’ordre de fabricació',
    production_production_summary: 'Sumant el taller',
    production_my_orders: 'Mirant el teu lloc',
    production_complete_phase: 'Marcant una fase del taller',
  },
  en: {
    production_find_production_orders: 'Looking through the manufacturing orders',
    production_production_order_detail: 'Reading the manufacturing order',
    production_production_summary: 'Adding up the shop floor',
    production_my_orders: 'Looking up your bench',
    production_complete_phase: 'Ticking a shop phase',
  },
  fr: {
    production_find_production_orders: 'Recherche parmi les ordres de fabrication',
    production_production_order_detail: 'Lecture de l’ordre de fabrication',
    production_production_summary: 'Bilan de l’atelier',
    production_my_orders: 'Consultation de votre poste',
    production_complete_phase: 'Validation d’une phase d’atelier',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
